<template>
	<div id="files">

		<div class="va-page-card">
			<div class="va-page-card-header">
				<div class="va-page-card-dot"></div>
				<span class="va-page-card-title">Files</span>
				<span class="va-page-card-count" v-if="count > 0">{{ count }}</span>
				<div class="fl-header-controls">
					<el-input
							class="fl-search"
							v-model="search"
							size="default"
							clearable
							@keyup.enter="fileFilter"
							placeholder="Type to search"/>
					<el-button size="default" type="primary" @click="fileFilter"><i class="fa-light fa-magnifying-glass"></i>&ensp;Search</el-button>
					<el-button v-if="createAccess" @click.prevent="newFile()" type="success" size="default"><i class="fa-light fa-cloud-arrow-up"></i>&ensp;Upload New File</el-button>
				</div>
			</div>

			<div v-loading="loading" class="va-page-card-body">

				<div class="va-section-header">
					<div class="va-section-title"><i class="fa-light fa-sliders va-section-icon"></i> Search &amp; Bulk Change Values</div>
				</div>

				<div class="fl-bulk-panel">
					<el-select key="select6" v-model="OrganizationIDs" class="oneHundred fl-clients-select mb-1" size="default" placeholder="Clients" multiple default-first-option filterable clearable>
						<el-option
								v-for="item in Organizations"
								:label="item.OrganizationName"
								:value="item.OrganizationID"
								:key="item.OrganizationID">
						</el-option>
					</el-select>

					<div class="fl-filter-bar">
						<el-select key="select1" size="small" class="fl-filter-select fl-filter-bpm" v-model="bpm" placeholder="BPM" default-first-option filterable clearable>
							<el-option
									v-for="item in BPMs"
									:key="item.FileSpecificationID"
									:label="item.SpecName"
									:value="item.FileSpecificationID">
							</el-option>
						</el-select>
						<el-select key="select2" size="small" class="fl-filter-select fl-filter-genre" v-model="genre" placeholder="Genre" default-first-option filterable clearable>
							<el-option
									v-for="item in Genres"
									:key="item.FileSpecificationID"
									:label="item.SpecName"
									:value="item.FileSpecificationID">
							</el-option>
						</el-select>
						<el-select key="select3" size="small" class="fl-filter-select fl-filter-mood" v-model="mood" placeholder="Mood" default-first-option filterable clearable>
							<el-option
									v-for="item in Moods"
									:key="item.FileSpecificationID"
									:label="item.SpecName"
									:value="item.FileSpecificationID">
							</el-option>
						</el-select>
						<el-select key="select4" size="small" class="fl-filter-select fl-filter-format" v-model="format" placeholder="Format" default-first-option filterable clearable>
							<el-option
									v-for="item in Formats"
									:key="item.FileSpecificationID"
									:label="item.SpecName"
									:value="item.FileSpecificationID">
							</el-option>
						</el-select>
						<el-select key="select5" size="small" class="fl-filter-select fl-filter-length" v-model="length" placeholder="Length" default-first-option filterable clearable>
							<el-option
									v-for="item in Lengths"
									:key="item.FileSpecificationID"
									:label="item.SpecName"
									:value="item.FileSpecificationID">
							</el-option>
						</el-select>
						<el-date-picker class="fl-filter-select fl-filter-date" v-model="postdate" size="small" default-first-option filterable clearable
										type="date"
										format="MMMM D, YYYY"
										value-format="YYYY-MM-DD"
										placeholder="Post Date">
						</el-date-picker>
						<el-radio-group v-model="archived" size="small" class="fl-status-radio">
							<el-radio-button value="" selected>No Status Change</el-radio-button>
							<el-radio-button value="n">Active</el-radio-button>
							<el-radio-button value="y">Archived</el-radio-button>
							<el-radio-button value="h">Historical</el-radio-button>
						</el-radio-group>
						<el-button size="default" type="warning" class="fl-bulk-btn" @click="bulkChangeCnfm"><i class="fa-light fa-pen-to-square"></i>&ensp;Bulk Change</el-button>
					</div>
				</div>

				<el-table v-loading="loading" class="mt-3"
						  :data="PageFiles"
						  ref="tablefiles"
						  border
						  key="tablefiles"
						  size="small"
						  max-height="600"
						  empty-text="No Files"
						  stripe
						  @selection-change="handleSelectionChange"
                          @sort-change="sortFile"
						  style="width: 100%">
					<el-table-column
							type="selection"
							align="center"
							width="50"
					>
					</el-table-column>
                    <el-table-column type="expand">
                        <template #default="scope">
                            <pre class="fl-json-block" v-html="scope.row.ParamsF"></pre>
                        </template>
                    </el-table-column>
					<el-table-column
							prop="sample"
							label="Sample"
							align="center"
							width="70">
						<template #default="scope">
							<span v-if="scope.row.SampleURL">
								<i v-if="scope.row.samplePlaying == 'n'" class="fa-light fa-circle-play fl-sample-icon" @click="playSound(scope.row.SampleURL);scope.row.samplePlaying = 'y';"></i>
								<i v-else class="fa-light fa-circle-pause fl-sample-icon fl-sample-icon--playing" @click="stopSound(scope.row.SampleURL);scope.row.samplePlaying = 'n';"></i>
							</span>
						</template>
					</el-table-column>
                    <el-table-column
                      prop="FileName"
                      label="Name"
                      min-width="120"
                      sortable="custom"
                    >
                      <template #default="scope">
                        <div v-html="scope.row.FileName" ></div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="ClientFileName"
                      label=" Client Name"
                      min-width="120"
                      sortable="custom"
                    >
                      <template #default="scope">
                        <div v-html="scope.row.ClientFileName" ></div>
                      </template>
                    </el-table-column>
					<el-table-column
							prop="TimeAgo"
							label="Uploaded"
							width="120"
                            sortable="custom"
					>
					</el-table-column>
					<el-table-column
							prop="filespecs"
							label="Properties"
							width="160"
					>
						<template #default="scope">
							<div v-if="scope.row.BPM" class="fl-prop-line">BPM: {{scope.row.BPM}}</div>
							<div v-if="scope.row.Mood" class="fl-prop-line">Mood: {{scope.row.Mood}}</div>
							<div v-if="scope.row.Length" class="fl-prop-line">Length: {{scope.row.Length}}</div>
							<div v-if="scope.row.Genre" class="fl-prop-line">Genre: {{scope.row.Genre}}</div>
							<div v-if="scope.row.Format" class="fl-prop-line">Format: {{scope.row.Format}}</div>
						</template>
					</el-table-column>
                    <el-table-column
                        prop="Size"
                        label="Size (mb)"
                        min-width="100"
                        align="center"
                        sortable="custom"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="Duration"
                        label="Duration"
                        min-width="100"
                        align="center"
                        sortable="custom"
                    >
                        <template #default="scope">
                            <span v-html="(scope.row.FileType == 'audio' ? scope.row.DurationF : '')"></span>
                        </template>
                    </el-table-column>
					<el-table-column
							prop="OrganizationNames"
							label="Clients"
							min-width="120"
					>
						<template #default="scope">
							<span v-html="scope.row.OrganizationNames"></span>
						</template>
					</el-table-column>
					<el-table-column
						prop="Archived"
						label="Status"
						width="80"
						:filters="[{ text: 'Active', value: 'n' }, { text: 'Archived', value: 'y' }, { text: 'Historical', value: 'h' }]"
						:filter-method="filterStatus"
						filter-placement="bottom-end"
						:filtered-value="['n','y','h']"
				>
					<template #default="scope">
						<span :class="{'fl-status-archived': scope.row.Archived == 'y', 'fl-status-historical': scope.row.Archived == 'h'}" v-html="(scope.row.Archived == 'y' ? 'Archived' : (scope.row.Archived == 'h' ? 'Historical' : 'Active'))"></span>
					</template>
				</el-table-column>
					<el-table-column v-if="modifyAccess"
									 label=""
									 width="90"
									 align="center">
						<template #default="scope">
							<a href="javascript:;" class="fl-row-icon" @click="editFile(scope.$index, scope.row)"><i class="fa-light fa-pen"></i></a>
							<a href="javascript:;" class="fl-row-icon" @click="deleteCnfm(scope.$index, scope.row)"><i class="fa-light fa-trash"></i></a>
						</template>
					</el-table-column>
					<el-table-column
							prop="file"
							label="Downloads"
							align="center"
							sortable
							:sort-method="sortDownloads"
							width="130"
					>
						<template #default="scope">
							<el-tooltip v-if="scope.row.DownloadCount" placement="top" effect="light">
								<template #content><div v-html="scope.row.DownloadList"></div></template>
								<span class="fl-download-count" v-html="scope.row.DownloadCount"></span>
							</el-tooltip>
							<el-button type="primary" size="small" @click="forceFileDownload(scope.row.FileID, scope.row.FullURL);" ><i class="fa-light fa-download"></i>&ensp;Download</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="fl-pagination">
					<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							background
							:hide-on-single-page="singlePage"
							:current-page.sync="currentPage"
							:page-sizes="[100, 500, 1000, 2000]"
							:page-size="100"
							layout="sizes, prev, pager, next"
							:total="count">
					</el-pagination>
				</div>
          <audio ref="audioPlayer" :src="currentFile" autoplay="true" preload="none"
                 v-on:ended="stopSound()"></audio>
			</div>
		</div>

		<modal v-if="showModal" :showMask="false" @close="showModal = false" @refreshData="reset">
            <template v-slot:header>
                <h5  class="modal-title">
                    {{modalTitle}}
                </h5>
            </template>
			<template v-slot:body >
				<FileUploads ref="file" :fileData="modalData" :config="config" @refreshData="reset" />
			</template>
			<template v-slot:footer>
				<div v-html="modalFooter"></div>
			</template>
		</modal>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import Modal from './global/Modal.vue';
	import FileUploads from './FileUploads.vue';
	import axios from 'axios';
    import Util from '../assets/js/util.js';

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
	export default {
		data () {
			return {
				loading: false,
				currentPage: 1,
				count: 0,
				sizePerPage: 100,
				singlePage : false,
				Files: [],
				FilteredFiles: [],
				PageFiles : [],
				search : '',
				showModal : false,
				modalTitle: 'Edit File',
				modalFooter: '&nbsp;',
				currentStatus : 0,
				currentFile : '',
				file : {},
				samplePlaying : 'n',
				bpm : '',
				genre : '',
				mood : '',
				format :'',
				length : '',
				archived : '',
				postdate : '',
				OrganizationIDs : [],
				BPMs : [],
				Genres : [],
				Moods : [],
				Formats : [],
				Lengths: [],
				Organizations : [],
				multipleSelection : [],
                sortProp : '',
                sortOrder : ''
			}
		},
		name: 'Files',
		components: {
			Modal,
			FileUploads
		},
		props: {
			config : { type: Object },
		},
		computed: {
			...mapGetters({ currentUser: 'currentUser' }),
			...mapGetters({ componentIDs: 'componentIDs' }),
			isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed() {
				return this.currentStatus === STATUS_FAILED;
			},
	        createAccess () {
                return Util.createAccess(this.currentUser);;
            },
	        modifyAccess () {
                return Util.modifyAccess(this.currentUser);
            },
		},
		methods: {
			handleSelectionChange (selection) {
				this.multipleSelection = selection;
			},
			filterStatus(value, row) {
				return row.Archived === value;
			},
			handleSizeChange(val) {
				this.sizePerPage = val;
				this.pageFilter();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.pageFilter();
			},
			pageFilter () {
				this.PageFiles = [];
				let start = (this.currentPage-1) * this.sizePerPage;
				for (let i=0; i < this.FilteredFiles.length; i++) {
					if (i >= start && this.PageFiles.length < this.sizePerPage) {
						this.PageFiles.push(this.FilteredFiles[i]);
					}
				}
				if (start == 0 && this.PageFiles.length < this.sizePerPage) {
					this.singlePage = true;
				} else {
					this.singlePage = false;
				}
			},
			fileFilter() {
				var goodFiles = [];
				var count = 0;
				for (let i=0; i < this.Files.length; i++) {
					var includeFile = true;

          if (this.search && !this.Files[i].FileName.toLowerCase().includes(this.search.toLowerCase())) {
            includeFile = false;
          }
                if (this.bpm && this.bpm != this.Files[i].BPMID) {
                    includeFile = false;
                }
                if (this.genre && this.genre != this.Files[i].GenreID) {
                    includeFile = false;
                }
                if (this.mood && this.mood != this.Files[i].MoodID) {
                    includeFile = false;
                }
                if (this.format && this.format != this.Files[i].FormatID) {
                    includeFile = false;
                }
                if (this.length && this.length != this.Files[i].LengthID) {
                    includeFile = false;
                }
                if (this.archived && this.archived != this.Files[i].Archived) {
                    includeFile = false;
                }

                if (includeFile && this.OrganizationIDs.length > 0) {
                    let orgFound = false;
                    for (let j=0; j < this.OrganizationIDs.length; j++) {
                        if (this.Files[i].OrganizationIDs.indexOf(this.OrganizationIDs[j]) !== -1) {
                            orgFound = true;
                            break;
                        }
                    }
                    includeFile = orgFound;
                }
                if (includeFile) {
                    goodFiles.push(this.Files[i]);
                }
            }
            this.FilteredFiles = goodFiles;
            this.count = this.FilteredFiles.length;
            this.currentPage = 1;
            this.pageFilter();
        },
      sortFile(data) {
          if (data.prop == 'TimeAgo') {
              data.prop = 'TimeAgoSort';
          }
          this.sortProp = data.prop;
          this.sortOrder = data.order;
          this.Files.sort(function(a, b) {
              if (data.prop == 'Duration' || data.prop == 'Size') {
                  if (data.order == 'ascending') {
                      var labelA = parseInt(a[data.prop].toString().toLowerCase().trim()),
                          labelB = parseInt(b[data.prop].toString().toLowerCase().trim());
                  } else {
                      var labelB = parseInt(a[data.prop].toString().toLowerCase().trim()),
                          labelA = parseInt(b[data.prop].toString().toLowerCase().trim());
                  }
                  var result = labelA - labelB;

                  return result;
              } else {
                  if (data.order == 'ascending') {
                      var labelA = a[data.prop].toString().toLowerCase().trim(),
                          labelB = b[data.prop].toString().toLowerCase().trim();
                  } else {
                      var labelB = a[data.prop].toString().toLowerCase().trim(),
                          labelA = b[data.prop].toString().toLowerCase().trim();
                  }
                  if (labelA < labelB) { //sort string ascending
                      return -1;
                  } else if (labelA > labelB) {
                      return 1
                  } else {
                      return 0 //default return value (no sorting)
                  }
              }
          });
        this.fileFilter();
      },
      playSound(file) {
        if (this.currentFile) {
          this.stopSound();
        }
        this.currentFile = file;
        this.audio = this.$refs.audioPlayer;
        var playPromise = this.audio.play();

        if (playPromise !== undefined) {
          playPromise.then(_ => {
          })
            .catch(error => {

            });
        }
      },
      stopSound() {
        this.currentFile = '';
        for (let i=0; i < this.PageFiles.length; i++) {
          this.PageFiles[i]['samplePlaying'] = 'n';
        }
        this.audio = this.$refs.audioPlayer;

        var playPromise = this.audio.pause();

        if (playPromise !== undefined) {
          playPromise.then(_ => {
          })
            .catch(error => {

            });
        }
      },
			sortDownloads (a,b) {
				return parseInt(a.DownloadCount) - parseInt(b.DownloadCount);
			},
            forceFileDownload(FileID, FullURL){
                axios.post('/files/downloadonly', {FileID : FileID}
                )
                    .then(response => {
                        if (response.data.result == 'success') {
                            const link = document.createElement('a');
                            link.href = response.data.FileURL;
                            var filename = FullURL.replace(/^.*[\\\/]/, '')
                            link.setAttribute('download', filename) //or any other extension
                            document.body.appendChild(link);
                            link.click();
                        } else {
                            this.$notify({
                                title: 'Error',
                                message: "File cannot be Downloaded",
                                type: 'error',
                                duration: 2000,
                                showClose: false
                            });
                        }
                    }).catch(response => {
                });
            },
			reset(showMessage) {
				// reset form to initial state
				this.showModal = false;
				this.currentStatus = STATUS_INITIAL;
				this.getInitialData ();

				if (showMessage) {
					this.$notify({
						title: 'Success',
						message: 'Data has been reset',
						type: 'success',
						duration: 1500,
						showClose: false
					});
                 }
			},
			getInitialData () {
				var tables = ['BPMs','Genres','Moods','Lengths','Formats','Organizations'];
				axios.post('/index/tableData', {'tables': tables },
				)
					.then(response => {
						if (response.data.result == 'success') {
							for (let value of tables) {
								this[value] = response.data[value];
							}
							this.getAllFiles();
						} else {
						}
					}).catch(response => {
				});
			},
			getAllFiles() {
				this.loading = true;
				axios.post('/files/getall', {},
				)
					.then(response => {
						if (response.data.result == 'success') {
                            for (let i = 0; i < response.data.Files.length; i++) {
                                response.data.Files[i].ParamsF = JSON.stringify(response.data.Files[i].Params, null, '\t');
                            }
							this.Files = response.data.Files;
							this.fileFilter();
							if (this.sortProp) {
                                this.$refs['tablefiles'].sort(this.sortProp, this.sortOrder);
                            };
						} else {
						}
						this.loading = false;
					}).catch(response => {
						this.loading = false;
				});
			},
			editFile(index, row) {
				this.modalTitle = 'Edit File';
				this.modalData = row;
				this.displayModal();
			},
			newFile() {
				this.modalTitle = 'Upload New File';
				this.modalData = {FileID : 0};
				this.displayModal();
			},
			displayModal () {
				this.showModal = true;
			},
			hideModal () {
				this.showModal = false;
			},
			bulkChangeCnfm() {
				if (this.multipleSelection.length > 0) {
					this.$confirm('You are about to bulk edit ' + this.multipleSelection.length + ' files. Continue?', 'Warning', {
						confirmButtonText: 'OK',
						cancelButtonText: 'Cancel',
						type: 'warning'
					}).then(() => {
						this.bulkSave();
					}).catch(() => {
					});
				}
			},
			bulkSave () {
				axios.post('/files/bulksave', {'Files': this.multipleSelection, OrganizationIDs :  this.OrganizationIDs, GenreID : this.genre, MoodID : this.mood, BPMID : this.bpm, FormatID : this.format, LengthID : this.length, Archived : this.archived, PostDate : this.postdate }
				)
					.then(response => {
						if (response.data.result == 'success') {
							this.$refs.tablefiles.clearSelection();
							this.getAllFiles();
							this.$notify({
								title: 'Success',
								message: "Files have been successfully saved.",
								type: 'success',
								duration: 1500,
								showClose: false
							});
						} else {
							this.$notify({
								title: 'Error',
								message: "Files could not be saved.",
								type: 'error',
								duration: 2000,
								showClose: false
							});
						}
					}).catch(response => {
					this.$notify({
						title: 'Error',
						message: "Files could not be saved.",
						type: 'error',
						duration: 2000,
						showClose: false
					});
				});
			},
			deleteCnfm (index,row) {
				this.$confirm('Are you sure you wish to delete this file?', 'Confirmation', {
					confirmButtonText: 'Yes',
					cancelButtonText: 'No',
					type: 'warning',
					showClose: false,
					showCancelButton: true
				}).then(() => {
					this.deleteFile(index, row);
				}).catch(() => {
				});

			},
			deleteFile(index, row) {
				axios.post('/files/delete', {'FileID': row.FileID}
				)
					.then(response => {
						if (response.data.result == 'success') {
							this.getAllFiles();
							this.$notify({
								title: 'Success',
								message: "File has been deleted",
								type: 'success',
								duration: 1500,
								showClose: false
							});
						} else {
							this.$notify({
								title: 'Error',
								message: "File cannot be deleted",
								type: 'error',
								duration: 2000,
								showClose: false
							});
						}
					}).catch(response => {
					this.$notify({
						title: 'Error',
						message: "File cannot be deleted",
						type: 'error',
						duration: 2000,
						showClose: false
					});
				});
			},
	        displayPopup (message) {
				this.$alert(message,  {
					type: 'error',
					confirmButtonText: 'OK',
				});
	        }
		},
		mounted() {

			this.getInitialData();
		},
	}
</script>
<style>
	#files .el-table th>.cell.highlight {
		color: var(--el-color-primary, #3F9CA8);
		font-weight: 800;
	}
	#files .el-table__column-filter-trigger i {
		color: var(--el-text-color-secondary, #64748B);
	}
</style>
<style scoped>

	.el-select {
		width: 100%;
		max-width: 300px;
	}
	table thead tr th:last-child {
		text-align: center;
	}

	/* ── Header controls (search + upload) ────────────────── */
	.fl-header-controls {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-left: auto;
		flex-wrap: wrap;
	}
	.fl-search { width: 220px; }

	/* ── Search & Bulk Change panel ──────────────────────────── */
	.fl-bulk-panel {
		background: var(--el-fill-color-extra-light, #FAFBFC);
		border: 1px solid var(--el-border-color, #E2E8F0);
		border-radius: 10px;
		padding: 16px;
		margin-bottom: 18px;
	}
	.fl-clients-select { max-width: 100%; margin-bottom: 12px; }
	.fl-filter-bar {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 10px;
	}
	#app .fl-filter-select { width: 100%; max-width: unset; flex: 0 0 auto; }
	#app .fl-filter-bpm    { width: 120px; }
	#app .fl-filter-genre  { width: 180px; }
	#app .fl-filter-mood   { width: 180px; }
	#app .fl-filter-format { width: 120px; }
	#app .fl-filter-length { width: 150px; }
	.fl-status-radio  { margin: 0; }
	.fl-bulk-btn      { margin-left: auto; }

	/* ── Table cell content ──────────────────────────────────── */
	.fl-prop-line {
		width: 100%;
		line-height: 14px;
		overflow-wrap: break-word;
	}
	.fl-sample-icon {
		font-size: 19px;
		cursor: pointer;
		color: var(--el-color-primary, #3F9CA8);
	}
	.fl-sample-icon--playing { color: var(--el-color-warning, #D97706); }
	.fl-row-icon {
		display: inline-block;
		font-size: 16px;
		margin: 0 6px;
		color: var(--el-text-color-secondary, #64748B);
	}
	.fl-row-icon:hover { color: var(--el-color-primary, #3F9CA8); }
	.fl-status-archived { color: var(--el-color-danger, #EF4444); font-weight: 600; }
	.fl-status-historical { color: var(--el-text-color-secondary, #64748B); font-weight: 600; }
	.fl-download-count {
		color: var(--el-color-primary, #3F9CA8);
		font-size: 13px;
		font-weight: 700;
		cursor: pointer;
		text-decoration: underline dotted;
		margin-right: 8px;
	}
	.fl-json-block {
		font-size: 12px;
		line-height: 1.5;
		font-family: 'SFMono-Regular', Consolas, monospace;
		background: var(--el-fill-color-light, #F1F5F9);
		border-radius: 6px;
		padding: 10px 14px;
		margin: 0;
		white-space: pre-wrap;
	}

	/* ── Pagination ──────────────────────────────────────────── */
	.fl-pagination {
		display: flex;
		justify-content: flex-end;
		margin-top: 14px;
	}
</style>
